import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Typography,
  Box,
  Button,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { styled } from "@mui/system";
import MemberAndPennantInfo from "./MemberAndPennantInfo";

// Styled components
const InfoContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
  minHeight: "100vh",
  padding: theme.spacing(3),
  paddingTop: theme.spacing(20),
  backgroundColor: theme.palette.background.default,
  [theme.breakpoints.down("sm")]: {
    paddingTop: theme.spacing(15),
  },
}));

// Remove or override maxWidth to allow child to use full available width
const InfoWrapper = styled(Box)(({ theme }) => ({
  width: "100%", // Let it stretch across the entire parent width
  padding: theme.spacing(3),
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[5],
  borderRadius: theme.shape.borderRadius,
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2),
    boxShadow: theme.shadows[2],
  },
}));

const BackButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));

function PublicMemberAndPennantInfo() {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <InfoContainer>
        <BackButton
  variant="contained"
  color="primary"
  onClick={async () => {
    try {
      await navigate("/public");
    } catch (err) {
      console.error("Navigation error:", err);
    }
  }}
>
  Back
</BackButton>

      <Typography
        variant={isMobile ? "h5" : "h4"}
        gutterBottom
        textAlign="center"
      >
        Membership & Pennant Information
      </Typography>

      <InfoWrapper>
        <MemberAndPennantInfo />
      </InfoWrapper>

      <BackButton
  variant="contained"
  color="primary"
  onClick={async () => {
    try {
      await navigate("/public");
    } catch (err) {
      console.error("Navigation error:", err);
    }
  }}
>
  Back
</BackButton>

    </InfoContainer>
  );
}

export default PublicMemberAndPennantInfo;
